import React from 'react'

import calculateVegetableAndFruitIntake from './calculateVegetableAndFruitIntake'

import { JournalEatableContainerObject } from 'Models'

const FRUIT_RECOMMENDED = 240
const VEGETABLE_RECOMMENDED = 360

const JournalCardVegetableAndFruitTracker: React.FC<{
  flattenedJournalEatableRecordsContainers: JournalEatableContainerObject[]
}> = ({ flattenedJournalEatableRecordsContainers }) => {
  const { vegetableIntake, fruitIntake } = calculateVegetableAndFruitIntake(flattenedJournalEatableRecordsContainers)

  const fruitPercent = Math.min((fruitIntake / FRUIT_RECOMMENDED) * 100, 100)
  const vegetablePercent = Math.min((vegetableIntake / VEGETABLE_RECOMMENDED) * 100, 100)
  const fruitLabel = 'Früchte'
  const vegetableLabel = 'Gemüse'

  return (
    <>
      <section className="standardcard pb-1">
        <ul className="intakemeter-container">
          <li className="intakemeter-item">
            <div className="standardcard-content py-1">
              <div className="standardcard-content standardcard-labelrow">
                <span className="pb-1">{vegetableLabel}</span>

                <span className="pb-1">
                  {vegetableIntake}&#8239;g / {VEGETABLE_RECOMMENDED}&#8239;g
                </span>
              </div>
              <div className="intakemeter-background">
                <div
                  className="intakemeter-bar"
                  role="meter"
                  aria-label={vegetableLabel}
                  aria-valuenow={vegetablePercent}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  style={{
                    width: `${vegetablePercent >= 5 ? vegetablePercent : 0}%`,

                    background: `linear-gradient(90deg, #ffe253, #97d154 ${
                      vegetablePercent > 0 ? 10000 / vegetablePercent : 0
                    }%)`
                  }}
                />
              </div>
            </div>
          </li>

          <li className="intakemeter-item">
            <div className="standardcard-content pb-1">
              <div className="standardcard-content standardcard-labelrow">
                <span className="pb-1">{fruitLabel} </span>

                <span className="pb-1">
                  {fruitIntake}&#8239;g / {FRUIT_RECOMMENDED}&#8239;g
                </span>
              </div>
              <div className="intakemeter-background">
                <div
                  className="intakemeter-bar"
                  role="meter"
                  aria-label={fruitLabel}
                  aria-valuenow={fruitPercent}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  style={{
                    width: `${fruitPercent >= 5 ? fruitPercent : 0}%`,
                    background: `linear-gradient(90deg, #ffe253, #97d154 ${
                      fruitPercent > 0 ? 10000 / fruitPercent : 0
                    }%)`
                  }}
                ></div>
              </div>
            </div>
          </li>
        </ul>
      </section>
    </>
  )
}

export default JournalCardVegetableAndFruitTracker
